import React from 'react';
import { CalendarItem } from './shared';
import { shortenString } from '@utils/string.util';
import { Col, Row } from 'antd';

type Props = {
  item: CalendarItem;
};

const CalendarItemCard = ({ item }: Props) => {
  return (
    <Row style={{ display: 'flex' }} gutter={20}>
      <Col style={{ fontWeight: 'bold' }}>{item.name}</Col>
      <Col>{shortenString(item.description, 50)}</Col>
    </Row>
  );
};

export default CalendarItemCard;
